import { yupResolver } from '@hookform/resolvers/yup';
import { useReinitializeForm } from 'hooks';
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useGetMembercenterPlansQuery, useGetUserQuery } from 'store/api/version-api.slice';

import PAYMENT_FORM_SCHEMA from './paymentForm.schema';
import UserPaymentForm from './UserPaymentForm';

const INITIAL_VALUES = {
	plan_type: '',
	first_name: '',
	last_name: '',
	email: '',
	save_card_information: true
};

const ContainerUserPaymentForm = ({
	isLoading,
	onSubmitHandler,
	isRenewForm,
	memberTypes,
	setLoading,
	initialValues
}) => {
	const { data: membercenterPlansResponse = {} } = useGetMembercenterPlansQuery();

	const memberCenterPlans = useMemo(
		() => membercenterPlansResponse.results || [],
		[membercenterPlansResponse.results]
	);

	const { data: userData = {} } = useGetUserQuery();

	const methods = useForm({
		defaultValues: initialValues || INITIAL_VALUES,
		resolver: yupResolver(PAYMENT_FORM_SCHEMA)
	});

	const initValues = useMemo(() => {
		if (isRenewForm) return initialValues;

		return {
			...initialValues,
			email: userData.email,
			first_name: userData.first_name,
			last_name: userData.last_name,
			save_card_information: true
		};
	}, [initialValues, isRenewForm, userData.email, userData.first_name, userData.last_name]);

	useReinitializeForm({
		reset: methods.reset,
		formValues: initValues
	});

	return (
		<FormProvider {...methods}>
			<UserPaymentForm
				plans={isRenewForm ? memberTypes : memberCenterPlans}
				isLoading={isLoading}
				isRenewForm={isRenewForm}
				onSubmitHandler={onSubmitHandler}
				setLoading={setLoading}
				initialValues={initialValues}
			/>
		</FormProvider>
	);
};

export default ContainerUserPaymentForm;
